require('../../modules/es6.number.statics');
module.exports = parseInt;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/number/parse-int.js
 ** module id = 526
 ** module chunks = 0
 **/